/* eslint-disable boundaries/dependencies */ import clsx from 'clsx';
import React from 'react';
import { Image } from '@colonist/ui';
import styles from './Avatar.module.scss';
import { PlayerColor, TradeResponseStatus } from '@colonist/game-states';
import { LobbyImage } from '@colonist/types';
import { getLobbyImagePath } from '../../../../../code/client/shared/scripts/ui_utils/Utils.ts';
import { ColonistMembershipProduct } from '../../../../../code/shared/store/ColonistMembershipProduct.ts';
import { navigateToPage } from '../../../../../code/client/shared/scripts/ui_utils/ClientUtils.ts';
import IconAddFriend from '@static/images/icon_add_friend.svg';
import EmbargoOverlay from '@static/images/avatar_embargo_overlay.svg';
import PlayerStatusAccept from '@static/images/player_status_accept.svg';
import PlayerStatusReject from '@static/images/player_status_reject.svg';
import PlayerStatusPending from '@static/images/player_status_pending.svg';
const getTradeResponseStatusImage = (tradeResponseStatus)=>{
    switch(tradeResponseStatus){
        case TradeResponseStatus.Accepted:
            return {
                src: PlayerStatusAccept,
                alt: 'strings:imgAlts.TradeAccepted'
            };
        case TradeResponseStatus.Rejected:
            return {
                src: PlayerStatusReject,
                alt: 'strings:imgAlts.TradeRejected'
            };
        case TradeResponseStatus.PendingResponse:
            return {
                src: PlayerStatusPending,
                alt: 'strings:imgAlts.TradePending'
            };
        case TradeResponseStatus.Embargoed:
            return undefined;
    }
};
export const Avatar = ({ className = '', image, color, hideBackground, showPlusIcon, membership, onClick, onMembershipClick, profilePictureUrl, isEmbargoed, tradeResponseStatus })=>{
    var _PlayerColor_color;
    const hasMembership = membership != null;
    const hasLobbyImage = image != null && !profilePictureUrl;
    const hasProfilePicture = profilePictureUrl != null;
    const hasColor = color != null;
    const backgroundColor = hasColor ? (_PlayerColor_color = PlayerColor[color]) === null || _PlayerColor_color === void 0 ? void 0 : _PlayerColor_color.toLowerCase() : null;
    const isBotImage = image === LobbyImage.Bot;
    const tradeResponseStatusImage = tradeResponseStatus != null ? getTradeResponseStatusImage(tradeResponseStatus) : null;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, backgroundColor && styles[backgroundColor], {
            [styles.hideBackground]: hideBackground || !hasColor,
            [styles.hasBackground]: hasColor && !hideBackground
        }, className),
        onClick: (e)=>{
            if (!onClick) return;
            e.stopPropagation();
            onClick();
        }
    }, showPlusIcon && /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.icon, styles.plus)
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.image,
        draggable: false,
        image: {
            src: IconAddFriend,
            alt: 'strings:imgAlts.AddFriend'
        }
    })), hasMembership && /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.icon, styles.membership),
        onClick: (e)=>{
            e.stopPropagation();
            if (onMembershipClick) onMembershipClick();
            else navigateToPage('/store#membership', true);
        }
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.image,
        draggable: false,
        image: {
            src: getLobbyImagePath(ColonistMembershipProduct.getMembershipProduct(membership).lobbyImage),
            alt: 'strings:imgAlts.Memberships'
        }
    })), isEmbargoed && /*#__PURE__*/ React.createElement(Image, {
        draggable: false,
        className: styles.embargoOverlay,
        image: {
            src: EmbargoOverlay,
            alt: 'strings:imgAlts.Embargo'
        }
    }), tradeResponseStatusImage && /*#__PURE__*/ React.createElement(Image, {
        draggable: false,
        className: styles.tradeResponseStatus,
        image: tradeResponseStatusImage
    }), hasLobbyImage && /*#__PURE__*/ React.createElement(Image, {
        draggable: false,
        className: clsx(styles.avatarImage, {
            [styles.isBot]: isBotImage,
            [styles.embargoed]: isEmbargoed
        }),
        image: {
            src: getLobbyImagePath(image),
            alt: isBotImage ? 'strings:imgAlts.Bot' : 'strings:imgAlts.PlayerAvatar'
        }
    }), hasProfilePicture && /*#__PURE__*/ React.createElement(Image, {
        draggable: false,
        className: clsx(styles.avatarImage, styles.profilePicture, {
            [styles.embargoed]: isEmbargoed
        }),
        image: {
            src: profilePictureUrl,
            alt: 'strings:imgAlts.ProfilePicture'
        }
    }));
};
